import Image from "next/image"
import { useLang } from "hooks/useLang"
import { useState, useEffect } from "react"

import data_en from "./funFactsData.json"
import data_ar from "./funFactsData.json"

const FunFactSection = ({ isLoading }: { isLoading: boolean }) => {
    const { t, lang } = useLang()

    const data = lang === "ar" ? data_ar : data_en

    // Pick a random fact only once
    const [fact, setFact] = useState<string | null>(null)

    useEffect(() => {
        const randomIndex = Math.floor(Math.random() * data.length)
        setFact(data[randomIndex]?.fact || "")
    }, []) // Empty dependency array ensures this runs only once

    const onRefreshClick = () => {
        const randomIndex = Math.floor(Math.random() * data.length)
        setFact(data[randomIndex]?.fact || "")
    }

    if (isLoading || !fact) {
        return null
    }

    return (
        <div className="w-full flex flex-col  px-8 py-8 layout md:max-w-[1220px] items-center md:items-start">
            <div className="flex flex-row justify-between w-full">
                <div>
                    <h2 className="capitalize text-[18px]">{t("funFact")}</h2>
                    <h2 className="text-2xl font-bold mb-1 capitalize">
                        {t("didYouKnow")}
                    </h2>
                </div>
                <div
                    className="cursor-pointer hover:opacity-50 transition-all"
                    onClick={onRefreshClick}
                >
                    <Image
                        src="/svg/refresh.svg"
                        alt="refresh"
                        width={30}
                        height={30}
                        className="w-[30px] h-[30px]"
                    />
                </div>
            </div>

            <div className="flex">
                <span className="text-[#B5B5B5] text-left">{fact}</span>
            </div>
        </div>
    )
}

export default FunFactSection
